import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/es'

moment.locale('es')


export const PickWithTies = (props) => {
  const {
    fixture,
    week,
    handlePick,
    selectedPick,
    selectedTeam,
    pointFormat,
    isFirstMatch,
    firstMatch,
    firstOfWeek,
    currentEntry,
    survivorInfo,
    selectedOtherWeeks,
    isUserSelectedFirstMatch,
    updateStartedFirstMatchOfWeek
  } = props

  const isPassedDeadlineWeek = firstOfWeek.time_left <= 0
  const isPassedMatchDeadline = fixture?.survivor_time_left <= 0
  const isTieSelected = selectedPick?.pick === null
    && (selectedPick?.tie === 1 || selectedPick?.tie === true)
    && selectedPick?.fixture_id === fixture?.id


  // Cambia el color de el contador dependiendo del tiempo restante
  // para comenzar el survivor
  const lessThan24Hours = fixture?.survivor_time_left < 86400

  // Si ya paso el primer partido
  const isPassedFirstMatchDate = firstMatch?.survivor_time_left <= 0

  let isDisabled = isPassedDeadlineWeek

  // Soccer
  if (survivorInfo.sport_id === 1 && isPassedFirstMatchDate) {
    isDisabled = true
  } else {
    // NFL
    // Desactiva si ya paso el primer partido pero no desactiva
    // Si aun no cierra la semana week.time_left === 0
    // y el usuario no escogio equipo del primer partido
    // -----------------------------------------------------
    if (isFirstMatch && isPassedFirstMatchDate) {
      isDisabled = true
    } else if (!isFirstMatch && isUserSelectedFirstMatch && isPassedFirstMatchDate) {
      isDisabled = true
    }
  }


  const isEntryAlive = currentEntry?.survivor_standing?.alive //currentEntry?.alive ?? currentEntry?.survivor_standing?.alive;

  // Deshabilitar si ya esta descalificado y el survivor ya comenzo
  if ((currentEntry && !isEntryAlive) || survivorInfo.status === 'closed') {
    isDisabled = true
  }

  const handleSelect = (type) => {
    if (isDisabled) return

    if (type === 'home' ) {
      handlePick(fixture?.home_team?.id, week.id, fixture?.id)
    } else if (type === 'away') {

      handlePick(fixture?.away_team?.id, week.id, fixture?.id)
    }
    else if (type === 'tie') {
      handlePick('tie', week.id, fixture?.id)
    }
  }

  useEffect(() => {
    let tick
    let count = 0

    if (isFirstMatch && firstMatch.survivor_time_left > 0) {
      count = firstMatch.survivor_time_left

      // Crear contador que cierra la opcion de seleccionar pick
      // Si ya paso la fecha de tiempo limite
      tick = window.setInterval(() => {
        count = count - 1

        if (count === 0) {
          updateStartedFirstMatchOfWeek(firstMatch)
          window.clearInterval(tick)
        }

      }, 1000)
    }

    return () => window.clearInterval(tick)
  }, [isFirstMatch, firstMatch])

  return (
    <PickRow isDisabled={isDisabled}>
      <div className='team home' onMouseDown={() => handleSelect('home')}>
        <PickBox>
          {(!selectedOtherWeeks?.[fixture?.home_team?.id] || selectedTeam?.id === fixture?.home_team?.id) && (
            <RadioButton isSelected={selectedPick?.pick === fixture?.home_team?.id} isDisabled={isDisabled} />
          )}
        </PickBox>

        <i className={'team-logo home ' + fixture?.home_team?.logo}></i>
        <TeamInfo>
          <Name>{fixture?.home_team.abbreviation}</Name>
          <TeamRecord teamData={fixture?.home_team} sportId={props?.survivorInfo?.sport_id}/>
        </TeamInfo>

        {pointFormat === 'line' && (
          fixture?.favorite !== null ? (
            <div>
              <LineHome>
                {fixture?.favorite === 'home' ? fixture?.advantage : null}
              </LineHome>
            </div>
          ) : (
            <LineHome></LineHome>
          )
        )}

      </div>

      <div className='team tie' onClick={() => handleSelect('tie')}>
        <PickBox>
          <RadioButton isSelected={isTieSelected} isDisabled={isDisabled} />
        </PickBox>
      </div>

      <div className='team away' onClick={() => handleSelect('away')}>
        {pointFormat === 'line' && (
          fixture?.favorite !== null ? (
            <LineAway>
              {fixture?.favorite === 'away' ? fixture?.advantage : null}
            </LineAway>
          ) : (
            <LineAway></LineAway>
          )
        )}

        <TeamInfo>
          <Name>{fixture?.away_team?.abbreviation}</Name>
          <TeamRecord teamData={fixture?.away_team} sportId={props?.survivorInfo?.sport_id} />
        </TeamInfo>

        <i className={'team-logo home ' + fixture?.away_team?.logo}></i>

        <PickBox>
          {(!selectedOtherWeeks?.[fixture?.away_team?.id] || selectedTeam?.id === fixture?.away_team?.id) && (
            <RadioButton isSelected={selectedPick?.pick === fixture?.away_team?.id} isDisabled={isDisabled} />
          )}
        </PickBox>
      </div>

      {!isPassedMatchDeadline && (
        <div className='date'
          style={{
            color: lessThan24Hours ? '#ff4047' : '#ff4047',
            display: 'flex',
            flexDirection: 'column',
            fontSize: '8px'
          }}
        >
          <div>{moment(fixture?.survivor_deadline).format('ddd  D H:mm')}</div>
        </div>
      )}

    </PickRow>
  )
}

// ---------------------------------------------------------------------

const LineHome = styled.span`
  color: yellow;
  position: absolute;
  right: 0.5em;
  top: 50%;
  transform: translateY(-50%);
  width: fit-content;
  font-size: 0.7em;
`

const LineAway = styled(LineHome)`
  left: 0.5em;
  top: 50%;
`

const PickRow = styled.div`
  width: 100%;
  height: 32px;
  min-height: 25px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.48fr) minmax(0, 1fr) minmax(38px, 5%);
  align-items: center;
  border-bottom: 1px solid #8f8f8f;
  text-align: center;
  position: relative;
  font-size: 0.9em;

  &:last-child {
    border-bottom: none;
  }

  .team {
    display: flex;
    align-items: center;
    height: 100%;
    min-width: 0;
    border-right: 1px solid #8f8f8f;
    padding: 0 0.4em;
    gap: 0.2em;
    position: relative;
    user-select: none;
    cursor: ${p => p.isDisabled ? 'default' : 'pointer'};
  }

  .home {
    display: grid;
    grid-template-columns: 15px auto minmax(0, 1fr);
    justify-items: start;
    align-items: center;
  }

  .tie {
    justify-content: center;
    padding: 0 0.2em;
  }

  .away {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto 15px;
    justify-items: end;
    align-items: center;
  }

  .date {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-width: 0;
    font-size: 9px;
    font-weight: bold;
    text-transform: uppercase;
    font-family: sans-serif;
  }
`

const TeamInfo = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  flex-wrap: wrap;

  ${PickRow} .away & {
    justify-content: flex-end;
    text-align: right;
  }
`

const Name = styled.span`
  font-weight: bolder;
  font-style: italic;
  font-family: Chivo;
  margin-right: 0.3em;
`

const PickBox = styled.div`
  flex: 0 0 15px;
  width: 15px;
  height: 15px;
`

const Glow = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0,0,0,0) 50%, rgba(255,255,255,0.6) 100%);
`

const RadioSelected = styled.span`
  font-size: 1.4em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
`

const Border = styled.div`
  border-radius: 50%;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${p => {
    if (p.isDisabled) return '2px solid #757575'
    if (p.isSelected) return '2px solid #78BC28'
    return '2px solid #ffffff'
  }};
`

const PickBall = styled.div`
  background-color: #78BC28;
  width: 5px;
  height: 5px;
  border-radius: 50%;
`

const RadioButton = ({ isSelected, isDisabled }) => {
  if (isSelected) {
    return (
      <>
        <Glow />
        <RadioSelected><Border isDisabled={isDisabled} isSelected><PickBall></PickBall></Border></RadioSelected>
      </>
    )
  }

  return (
    <RadioSelected><Border isDisabled={isDisabled}></Border></RadioSelected>
  )
}

const TeamRecord = ({ teamData, sportId }) => {
  let conditionalComponent = null;

  if (teamData?.team_stats && teamData.team_stats.hasOwnProperty('win')) {
    if (sportId === 1) {
      conditionalComponent = (
        <small className=''>
          {`(${teamData?.team_stats?.win}-${teamData?.team_stats?.ties}-${teamData?.team_stats?.lost}) `}
        </small>
      );
    } else {
      conditionalComponent = (
        <small className=''>
          {`(${teamData.team_stats.win}-${teamData.team_stats.lost}) `}
        </small>
      );
    }
  }

  return conditionalComponent;
};